/* eslint-disable import/no-unresolved */
import { useMutation } from '@apollo/client';
import { useState } from 'react';

import { CREATE_DIRECTORY } from 'Apollo/Mutations/DataRecon';
import CreateNewFolder from '../components/CreateNewFolder';

const CreateNewFolderContainer = ({
    visible, setVisible, currentDir, getDirDetails, fileExplorerDataSource, setToastMessage,
}) => {
    const [folderName, setFolderName] = useState('');
    const [folderNameError, setFolderNameError] = useState(false);
    const [folderNameIsValid, setFolderNameIsValid] = useState(false);
    const [isFolderNameExist, setIsFolderNameExist] = useState(false);

    const reg = new RegExp('^[^\\/?*:|"<>]+$');

    const [createFolder, { loading: createFolderIsLoading }] = useMutation(CREATE_DIRECTORY);

    const inputHandler = value => {
        setFolderName(value);
        if (value.trim() === '') {
            setFolderNameError(true);
        } else {
            setFolderNameError(false);
        }
    };

    const onBlurHandler = (event => {
        if (event.target.value.trim() === '') {
            setFolderNameError(true);
        } else {
            setFolderNameError(false);
        }

        if (event.target.value.trim() !== '' && !reg.test(event.target.value.trim())) {
            setFolderNameIsValid(true);
        } else {
            setFolderNameIsValid(false);
        }
    });

    const isFolderExist = () => (fileExplorerDataSource && fileExplorerDataSource.find(element => element.name.toUpperCase() === folderName.toUpperCase()));

    const onSave = async e => {
        e.preventDefault();
        setFolderNameError(false);
        setIsFolderNameExist(false);
        if (!folderName || folderName.trim() === '') {
            setFolderNameError(true);
            return;
        }
        if (folderName.trim() !== '' && !reg.test(folderName.trim())) {
            setFolderNameIsValid(true);
            return;
        }
        if (isFolderExist()) {
            setIsFolderNameExist(true);
            return;
        }

        if (createFolderIsLoading) {
            return;
        }

        await createFolder({
            variables: {
                dirName: folderName,
                parentDirId: currentDir,
            },
        }).then(() => {
            setToastMessage('Folder creatation is complete.');
        });
        setVisible(false);
        getDirDetails();
    };

    return (
        <CreateNewFolder
            folderName={folderName}
            inputHandler={inputHandler}
            onBlurHandler={onBlurHandler}
            folderNameError={folderNameError}
            folderNameIsValid={folderNameIsValid}
            visible={visible}
            setVisible={setVisible}
            onSave={onSave}
            loading={createFolderIsLoading}
            isFolderNameExist={isFolderNameExist}
        />
    );
};

export default CreateNewFolderContainer;
